{
  "facebookSettingsCommon": {
    "profileImage": "Profilbild",
    "pageInfo": "Seiteninformationen",
    "imprint": "Impressum"
  }
}
